package com.eladfinish.bible.contest.screens.browse.usecases

import com.eladfinish.bible.contest.screens.mikud.MikudRepository
import com.eladfinish.bible.contest.screens.mikud.model.Selection

class GetBooksSelectionUseCase(
    private val mikudRepository: MikudRepository,
) {

    operator fun invoke(): List<Selection> =
        mikudRepository.getBookState().map {
            when (it.includedChaptersCount) {
                0 -> Selection.NONE
                it.chapters.size -> Selection.ALL
                else -> Selection.PARTIAL
            }
        }
}
